// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { listMeetingBotsRequestToJson, listMeetingBotsResponseFromJson, overridePrivacyRequestToJson, overridePrivacyResponseFromJson, scheduleBotRequestToJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function scheduleBot(request) {
    await fetchRpc('meeting_analysis.v1.MeetingBotService/ScheduleBot', scheduleBotRequestToJson(request));
}
export function scheduleBot$(request, options) {
    return defer(() => scheduleBotWithTransport$(getGlobalTransport(), request, options));
}
export function scheduleBotWithTransport$(transport, request, options) {
    return transport
        .post('meeting_analysis.v1.MeetingBotService/ScheduleBot', scheduleBotRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function listMeetingBots(request) {
    const raw = await fetchRpc('meeting_analysis.v1.MeetingBotService/ListMeetingBots', listMeetingBotsRequestToJson(request));
    return listMeetingBotsResponseFromJson(raw);
}
export function listMeetingBots$(request, options) {
    return defer(() => listMeetingBotsWithTransport$(getGlobalTransport(), request, options));
}
export function listMeetingBotsWithTransport$(transport, request, options) {
    return transport
        .post('meeting_analysis.v1.MeetingBotService/ListMeetingBots', listMeetingBotsRequestToJson(request), options)
        .pipe(map(resp => listMeetingBotsResponseFromJson(resp)));
}
export async function overridePrivacy(request) {
    const raw = await fetchRpc('meeting_analysis.v1.MeetingBotService/OverridePrivacy', overridePrivacyRequestToJson(request));
    return overridePrivacyResponseFromJson(raw);
}
export function overridePrivacy$(request, options) {
    return defer(() => overridePrivacyWithTransport$(getGlobalTransport(), request, options));
}
export function overridePrivacyWithTransport$(transport, request, options) {
    return transport
        .post('meeting_analysis.v1.MeetingBotService/OverridePrivacy', overridePrivacyRequestToJson(request), options)
        .pipe(map(resp => overridePrivacyResponseFromJson(resp)));
}
